import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

import { store } from 'src/app/store';
import { InversionShader } from 'src/shaders/InversionShader';
import { initialState } from 'src/state/renderer/rendererSlice';

import { renderer, scene, camera } from './scene';

export const composer = new EffectComposer( renderer );

const renderPass = new RenderPass( scene, camera );
composer.addPass( renderPass );

export const inversionPass = new ShaderPass(InversionShader);
inversionPass.uniforms['invert'].value = initialState.invertColors;
composer.addPass(inversionPass);

let invertColors = store.getState().renderer.invertColors;
onStateChange();

store.subscribe(onStateChange);

function onStateChange() {
  const state = store.getState();

  if (state.renderer.invertColors !== invertColors) {
    invertColors = state.renderer.invertColors;
    inversionPass.uniforms['invert'].value = invertColors
  }
}
